import ready from './lib/ready';
import promiseIdle from './lib/promise-idle';
import mergeOpts from './lib/merge-opts';
import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';

export const defaults = {
    modules: [Navigation, Pagination],
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
};

ready().then(promiseIdle()).then(function init() {
    reload() && document.addEventListener('reload', function () {
        Promise.resolve().then(promiseIdle()).then(reload);
    });
});

function reload() {
    document.querySelectorAll('.slider--auto:not(.swiper-initialized)').forEach((slider) => {
        const o = JSON.parse(slider.getAttribute('data-slider-options')) || {};
        const options = mergeOpts(defaults, o);
        new Swiper(slider, options);
    });
}
